export const NOMBRE = 'Álvaro Fernández García';
export const EMAIL = 'fernandezgarcia.alvaro@outlook.com';

export const EXPERIENCE_SPANISH = [
  {
    company: 'Novabase',
    location: 'Madrid',
    duration: 'Diciembre 2020 - Actualidad',
    technologies: [
      'ReactJS',
      'ARC Publishing'
    ],
    slug: 'http://www.novabase.es/',
    projects: [
      {
        name: 'Diario AS',
        description:
          'Migración de la página de Diario AS a tecnología ARC perteneciente al Washington Post'
      }
    ]
  },
  {
    company: 'Serbatic',
    location: 'Madrid',
    duration: 'Enero 2019 - Diciembre 2020',
    technologies: [
      'VueJS',
      'ReactJS',
      'Redux',
      'NodeJS',
      'Loopback',
      'DialogFlow',
      'Azure Bot Service',
      'Bootstrap',
      'Sass'
    ],
    slug: 'http://www.serbatic.es/',
    projects: [
      {
        name: 'Chatbot AXA',
        description:
          'Desarrollo de un componente para crear flujos de Chatbot con una herramienta basada en Blockly de Google'
      },
      {
        name: 'Movistar Money Colombia',
        description:
          'Desarrollo y mantenimiento de una Aplicación Web para contratar créditos en Colombia',
        slug: 'https://www.movistar.co/money/'
      },
      {
        name: 'Movistar FinTer',
        description:
          'Desarrollo y mantenimiento de una Aplicación Web para financiar terminales desde las tiendas de Movistar en Colombia'
      }
    ]
  },
  {
    company: 'BinPar Team Quality',
    location: 'Madrid',
    duration: 'Abril 2017 - Diciembre 2018',
    projects: [
      {
        slug: 'http://www.joyeriatequiero.com/',
        name: 'JOYERIAS TQ',
        description:
          'Desarrollo del Back-End de un conjunto de joyerías. Venta, gestión, registro de productos.'
      },
      {
        slug: 'https://www.art-madrid.com/',
        name: 'ART-MADRID',
        description:
          'Desarrollo del Back-End de una galería de arte y participación en el desarrollo del front de la misma.'
      },
      {
        slug: 'https://www.galeriabat.com/es',
        name: 'Galería BAT',
        description:
          'Participación en el desarrollo del Back-End de una galería de arte y en el desarrollo del front de la misma.'
      },
      {
        slug: 'https://edinumen.es/',
        name: 'EDINUMEN',
        description:
          'Desarrollo de aplicación web y aplicación móvil para leer libros electrónicos online y hacer ejercicios.'
      },
      {
        slug: 'https://axon.es/',
        name: 'AXON',
        description:
          'Desarrollo de aplicación web dedicada de la venta de productos y libros de medicina.'
      }
    ],
    technologies: [
      'ASP.NET',
      'SQL',
      'NodeJS',
      'GraphQL',
      'Apollo',
      'MongoDB',
      'Meteor',
      'ReactJS',
      'NextJS',
      'React Native',
      'HTML5',
      'CSS',
      'Material-UI'
    ],
    slug: 'https://www.binpar.com/'
  },
  {
    company: 'Miotek Factory',
    location: 'Madrid',
    duration: 'Octubre 2016 - Abril 2017',
    projects: [
      {
        slug: 'https://www.ipmicro.es/',
        name: 'Back-End IPMICRO',
        description: 'Desarrollo del Back-End de una clínica de podología.'
      },
      {
        name: 'SPORT REVIEW',
        description:
          'Desarrollo de una aplicación web sobre una red social deportiva y desarrollo de un extractor de noticias de más de 100 medios de comunicación.'
      }
    ],
    technologies: ['ASP.NET', 'SQL', 'HTML5', 'CSS'],
    slug: 'https://www.miotek.es/'
  }
];
export const EXPERIENCE_ENGLISH = [
  {
    company: 'Novabase',
    location: 'Madrid',
    duration: 'December 2020 - Present',
    technologies: [
      'ReactJS',
      'ARC Publishing'
    ],
    slug: 'http://www.novabase.es/',
    projects: [
      {
        name: 'Diario AS',
        description:
          'Migration of the Diario AS page to ARC technology that belongs to the Washington Post'
      }
    ]
  },
  {
    company: 'Serbatic',
    location: 'Madrid',
    duration: 'January 2019 - December 2020',
    projects: [
      {
        name: 'Chatbot AXA',
        description:
          'Development of a component for build Chatbot workflows with a tool based on Google Blockly'
      },
      {
        name: 'Movistar Money Colombia',
        description: 'Development and maintenance of a Web Application to hire credits in Colombia',
        slug: 'https://www.movistar.co/money/'
      },
      {
        name: 'Movistar FinTer',
        description:
          'Development and maintenance of a Web Application to finance terminals in Movistar Colombia stores'
      }
    ],
    technologies: [
      'VueJS',
      'ReactJS',
      'Redux',
      'NodeJS',
      'Loopback',
      'DialogFlow',
      'Azure Bot Service',
      'Bootstrap',
      'Sass'
    ],
    slug: 'http://www.serbatic.es/'
  },
  {
    company: 'BinPar Team Quality',
    location: 'Madrid',
    duration: 'April 2017 - December 2018',
    projects: [
      {
        slug: 'http://www.joyeriatequiero.com/',
        name: 'JOYERIAS TQ',
        description:
          'Development of the Back-End of a set of jewelry. Sales, management, product registration.'
      },
      {
        slug: 'https://www.art-madrid.com/',
        name: 'ART-MADRID',
        description:
          'Development of the Back-End of a gallery of art and participation in the development of the front of it.'
      },
      {
        slug: 'https://www.galeriabat.com/es',
        name: 'Galería BAT',
        description:
          'Participation in the development of the Back-End of an art gallery and in the development of the front of it.'
      },
      {
        slug: 'https://edinumen.es/',
        name: 'EDINUMEN',
        description:
          'Development of web application and mobile application for reading electronic books online and do exercises.'
      },
      {
        slug: 'https://axon.es/',
        name: 'AXON',
        description:
          'Development of dedicated web application from the sale of products and books of medicine.'
      }
    ],
    technologies: [
      'ASP.NET',
      'SQL',
      'NodeJS',
      'GraphQL',
      'Apollo',
      'MongoDB',
      'Meteor',
      'ReactJS',
      'NextJS',
      'React Native',
      'HTML5',
      'CSS',
      'Material-UI'
    ],
    slug: 'https://www.binpar.com/'
  },
  {
    company: 'Miotek Factory',
    location: 'Madrid',
    duration: 'October 2016 - April 2017',
    projects: [
      {
        slug: 'https://www.ipmicro.es/',
        name: 'Back-End IPMICRO',
        description: 'Development of podiatry clinic Back-End.'
      },
      {
        name: 'SPORT REVIEW',
        description:
          'Development of a web application on a sports social network and an extractor for news of more than 100 media development.'
      }
    ],
    technologies: ['ASP.NET', 'SQL', 'HTML5', 'CSS'],
    slug: 'https://www.miotek.es/'
  }
];

export const EDUCATION_SPANISH = [
  {
    school: 'IES Azarquiel',
    location: 'Toledo',
    title: 'Desarrollo de Aplicaciones Multiplataforma',
    duration: 'Octubre 2013 - Junio 2016',
    slug: 'http://www.ies-azarquiel.es/'
  },
  {
    school: 'IES Carlos III',
    location: 'Toledo',
    title: 'Bachillerato de Ciencias Tecnológicas',
    duration: 'Septiembre 2011 - Septiembre 2013',
    slug: 'http://ies-carlos3.centros.castillalamancha.es/'
  },
  {
    school: 'San Juan Bautista',
    location: 'Toledo',
    title: 'Educación Secundaria Obligatoria',
    duration: 'Septiembre 2006 - Junio 2011',
    slug: 'http://www.colegiotavera.com/'
  }
];
export const EDUCATION_ENGLISH = [
  {
    school: 'IES Azarquiel',
    location: 'Toledo',
    title: 'Cross-platform application development',
    duration: 'October 2013 - June 2016',
    slug: 'http://www.ies-azarquiel.es/'
  },
  {
    school: 'IES Carlos III',
    location: 'Toledo',
    title: 'Bachelor of technological Sciences',
    duration: 'September 2011 - September 2013',
    slug: 'http://ies-carlos3.centros.castillalamancha.es/'
  },
  {
    school: 'San Juan Bautista',
    location: 'Toledo',
    title: 'Compulsory secondary education',
    duration: 'September 2006 - June 2011',
    slug: 'http://www.colegiotavera.com/'
  }
];

export const LANGUAGES_SPANISH = [
  {
    language: 'Inglés',
    certificate: 'Preliminary English Test (B1)',
    slug: 'https://www.cambridgeenglish.org/es/exams-and-tests/preliminary/'
  }
];
export const LANGUAGES_ENGLISH = [
  {
    language: 'English',
    certificate: 'Preliminary English Test (B1)',
    slug: 'https://www.cambridgeenglish.org/es/exams-and-tests/preliminary/'
  }
];

export const PROJECTS = [
  {
    title: 'CHATBOT',
    link: 'https://dialogflowfront-alvarofg95.herokuapp.com/',
    background: '#b0e2f0',
    color: '#000',
    technologies: ['ReactJS', 'NodeJS', 'DialogFlow']
  },
  {
    title: 'CONTADOR DE PALABRAS',
    link: 'https://contadordepalabras.netlify.com/',
    background: '#FFF',
    color: '#000',
    technologies: ['ReactJS']
  },
  {
    title: 'HORA DE DORMIR',
    link: 'https://hora-de-dormir.netlify.com/',
    background: '#322f3d',
    color: '#FFF',
    technologies: ['ReactJS']
  },
  {
    title: 'RAPID NOTES',
    link: 'https://rapid-notes.netlify.com/',
    background: '#FFF',
    color: '#000',
    technologies: ['VueJS']
  },
  {
    title: 'WEATHER',
    link: 'https://tiempo-react.netlify.app/',
    background: '#322f3d',
    color: '#FFF',
    technologies: ['ReactJS']
  }
];
